import { sortBy } from 'gleam-shared/helpers/nodash'
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { readDomIdle, writeDomIdle, cancelFastDom } from 'gleam-shared/browser/fastDom'

export default function useAutoScroller(containerRef, itemsRef, rootFragmentRef) {
  let observer = null
  const activeRef = ref(null)
  const sortedItemsRef = ref(null)

  onMounted(delayMeasurement)
  onUnmounted(pause)

  watch(itemsRef, delayMeasurement)
  watch([sortedItemsRef, rootFragmentRef], chooseActiveItem)
  watch(activeRef, delayCalculation)

  watch(containerRef, (newContainer, oldContainer) => {
    if (newContainer) {
      start(newContainer, oldContainer)
    } else {
      pause()
    }
  })

  function start(newContainer, oldContainer) {
    observer = new ResizeObserver(delayCalculation)

    if (oldContainer) {
      observer.unobserve(oldContainer)
    }

    observer.observe(newContainer)
  }

  function pause() {
    observer.disconnect()
    observer = null

    cancelFastDom(update)
    cancelFastDom(measure)
    cancelFastDom(calculate)
  }

  function chooseActiveItem() {
    if (!sortedItemsRef.value || !rootFragmentRef.value) {
      return
    }

    activeRef.value = sortedItemsRef.value.find((item) => {
      return extractFragment(item) === rootFragmentRef.value
    })
  }

  function delayMeasurement() {
    readDomIdle(measure)
  }

  function measure() {
    if (!itemsRef.value) {
      return
    }

    sortedItemsRef.value = sortBy(itemsRef.value, (item) => {
      return item.getBoundingClientRect().top
    })
  }

  function delayCalculation() {
    readDomIdle(calculate)
  }

  function calculate() {
    if (!containerRef.value || !activeRef.value) {
      return
    }

    const cnRect = containerRef.value.getBoundingClientRect()
    const elRect = activeRef.value.getBoundingClientRect()
    const inView = elRect.top >= cnRect.top && (elRect.bottom  <= cnRect.bottom)

    if (inView) {
      return
    }

    const topCloser = elRect.top < cnRect.top
    const scrollTop = topCloser
      ? elRect.top - cnRect.top + containerRef.value.scrollTop
      : elRect.bottom - cnRect.bottom + containerRef.value.scrollTop

    writeDomIdle(update, scrollTop)
  }

  function update(scrollTop) {
    if (!containerRef.value) {
      return
    }

    containerRef.value.scrollTo({ top: scrollTop, behavior: 'smooth' })
  }
}

function extractFragment(item) {
  return item.querySelector('a').hash.replace('#', '')
}
